import React from 'react';
import { Drawer } from '@material-ui/core';
import styled from 'styled-components';
import { SectionDrawerProps } from './types';

const BUTTON_CONTAINER_HEIGHT = 16;
const DRAWER_WIDTH = 320;

export const SectionDrawer = styled(
    ({ offset, ...other }: SectionDrawerProps) => <Drawer {...other} />)`
    .MuiDrawer-paper {
        position: absolute;
        top: ${({ theme, offset }) => `${offset + theme.spacing(6)}px`};
        width: ${DRAWER_WIDTH}px;
        height: ${({ theme, offset }) => `calc(100% - ${offset + theme.spacing(6)}px)`};
    }
  `;

export const SectionListContainer = styled.div<{ parentHeight?: number }>`
    position: absolute;
    overflow-x: scroll;
    width: ${DRAWER_WIDTH}px;
    box-sizing: border-box;
    padding: ${({ theme }) => `${theme.spacing(5)}px ${theme.spacing(2)}px`};
    height: ${({ theme, parentHeight }) => parentHeight ? `${parentHeight - theme.spacing(BUTTON_CONTAINER_HEIGHT)}px` : `100%`};
`;

export const ButtonContainer = styled.div`
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-top: 1px solid #dddddd;
    border-bottom: 1px transparent;
    ${({ theme }) => `
        height: ${theme.spacing(BUTTON_CONTAINER_HEIGHT)}px;
    `}
`;